module.exports = __webpack_public_path__ + "img/search-md.538641a8.svg";